import { cn } from "@/lib/utils";

type Props = {
  label: string;
  children: React.ReactNode;
  classNameContainer?: string;
  classNameLabel?: string;
  classNameChildren?: string;
  gapWidth?: number;
};

export default function FormRow({
  label,
  children,
  classNameContainer,
  classNameLabel,
  classNameChildren,
  gapWidth,
}: Props) {
  return (
    <div
      className={cn(
        "flex h-10 w-full items-center justify-between gap-2",
        classNameContainer,
      )}
    >
      <span
        className={cn(
          "block w-[90px] overflow-hidden text-sm font-medium text-ellipsis whitespace-nowrap",
          classNameLabel,
        )}
      >
        {label}
      </span>
      <div style={{ width: gapWidth ?? 0 }} />
      <div className={cn("flex flex-1 items-center", classNameChildren)}>
        {children}
      </div>
    </div>
  );
}
